import { AiWorkbenchMessage } from '#screens/ai-workbench/ai-workbench-message.js';
import { useWizardHilContext } from '#screens/ai-workbench/wizard-hil-context.js';

export interface HilReviewTableMarkdownItemProps {
	/** Key into the nearest {@link WizardHilContext} result map. */
	hilResultId?: string;
}

/**
 * Renders a wizard HIL review table inline in a workbench message.
 *
 * @param hilResultId - Opaque key into the wizard HIL context result map.
 */
export function HilReviewTableMarkdownItem({ hilResultId }: HilReviewTableMarkdownItemProps) {
	const context = useWizardHilContext();

	if (!hilResultId || !context?.extractionContext) {
		return null;
	}

	const data = context.getResult(hilResultId);
	if (data === undefined) {
		return null;
	}

	return <AiWorkbenchMessage parseResult={data as object} aiExtractionContext={context.extractionContext} />;
}
